import { GetSchedulesByExperienceIdResponseBodyType } from "@intelligems/ig-types/functions/schedules/get-experience-schedules";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { scheduleKeys } from "../queryKeys";

const getExperienceSchedules = async (experienceId: string) => {
  const resp = await api.get<GetSchedulesByExperienceIdResponseBodyType>(
    `/v2/schedules/experiences/${experienceId}`
  );
  return resp.data;
};

export const useGetExperienceSchedules = (
  experienceId: string | undefined,
  options?: { enabled?: boolean }
) => {
  return useQuery<GetSchedulesByExperienceIdResponseBodyType, Error>({
    queryKey: scheduleKeys.one(experienceId!),
    queryFn: async () => getExperienceSchedules(experienceId!),
    enabled: !!experienceId && (options?.enabled ?? true),
    // Schedules change rarely and edits write straight to this cache via
    // setQueryData(scheduleKeys.one(...)). Without a staleTime this query
    // re-fetches on every mount — and it renders once per row in list tables
    // (StatusRenderer), so scrolling / cell remounts trigger a request storm.
    // Caching keeps the data correct while killing the redundant fetches.
    staleTime: 5 * 60 * 1000,
  });
};
